import React from 'react';
import CompanyForm from '../components/CompanyForm';

const CreateCompany: React.FC = () => {
  return (
    <div className="max-w-app mx-auto px-6 py-8">
      <CompanyForm mode="create" />
    </div>
  );
};

export default CreateCompany;
